import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCaretDown } from '@fortawesome/free-solid-svg-icons';
import popupHOC from '../common/popupHOC';
import { appPath } from '../../constants';
import UsersService from '../../services/UsersService';
import VersionComponent from '../VersionComponent';

class AccountMenu extends Component {
  static propTypes = {
    fullName: PropTypes.string.isRequired,
    closeMobileAsideMenu: PropTypes.func.isRequired,
    logOut: PropTypes.func.isRequired,
    history: PropTypes.object.isRequired,
    toggleMenu: PropTypes.func.isRequired,
    isOpen: PropTypes.bool.isRequired,
    closeMenu: PropTypes.func.isRequired
  };

  logout = () => {
    const { logOut, closeMobileAsideMenu, history } = this.props;
    logOut().then(() => {
      closeMobileAsideMenu();
      history.push(`/`);
    });
  };

  navToChangePassword = () => this.closeMenusAndRedirect('/change-password');

  navToProfile = () => this.closeMenusAndRedirect(`/${appPath}/profile`);

  closeMenusAndRedirect = pathToRedirect => {
    this.props.closeMenu();
    this.props.closeMobileAsideMenu();
    this.props.history.push(pathToRedirect);
  };

  render () {
    const { fullName, toggleMenu, isOpen } = this.props;
    return (
      <div className='account-menu-wrapper'>
        <div className='dropdown-wrapper' onClick={toggleMenu}>
          <div className='user-name'>{fullName}</div>
          <div className='caret-icon'>
            <FontAwesomeIcon icon={faCaretDown} />
          </div>
        </div>
        {isOpen && (
          <ul className='account-menu'>
            { UsersService.isEmployer() && <li onClick={this.navToProfile}>My Profile</li> }
            <li onClick={this.navToChangePassword}>Change Password</li>
            <li onClick={this.logout}>Log out</li>
            <li><VersionComponent /></li>
          </ul>
        )}
      </div>
    );
  }
}

export default popupHOC(AccountMenu);



// WEBPACK FOOTER //
// ./src/components/navigation/AccountMenu.js